module.exports = __webpack_public_path__ + "img/bg_top.d818c445.png";